// import {select} from '@ngrx/store';
import {AACFileInfo} from './AAC_FileInfo';


export class NICEFile
{
    busNo: number;
    entryID: number;
    fileName: string;
    fullFileName: string;
    fileNameWithPath: string;
    isFolder: boolean;
    folderID: number;
    protected: boolean;
    weblink: string;
    description: string;
    contactID: number;
    version: number;
    created: string;
    modified: string;
    accessed: string;
    authorID: string;
    modifiedID: number;
    size: number;
    physicalBytes: number;
    numFiles: number;
    deleteTime: string;
    purpose: string;
    volumeID: number;
    physicalLocation: string;
    isDeleted: boolean;
    volumeStatus: string;
    mailStatus: string;
    childCount: number;
    totalCount: number;
    totalPhysicalBytes: number;
    isAuthorized: boolean;
    cloudLocation: string;
    cloudEntryID: number;
    needsProcessing: boolean;
    state: string;
    purposeID: number;
    fileType: string;
    extension: string;
    location: string;
    voiceId: string;
    translation: string;
    aacFileInfo: AACFileInfo;

    constructor(niceFile?) {
        if (niceFile != null) {
            if (niceFile.fileNameWithPath)
            {
                niceFile.fullFileName = niceFile.fileNameWithPath;
            }
            this.busNo = niceFile.busNo;
            this.entryID = niceFile.entryID;
            this.fileName = niceFile.fileName || '';
            this.fullFileName = niceFile.fullFileName || '';
            this.fullFileName = this.fullFileName.replace('\\', '/');
            this.fileNameWithPath = this.fullFileName || '';
            this.isFolder = niceFile.isFolder || false;
            this.folderID = niceFile.folderID;
            this.protected = niceFile.protected || false;
            this.weblink = niceFile.weblink || '';
            this.description = niceFile.description || '';
            this.contactID = niceFile.contactID;
            this.version = niceFile.version;
            this.created = niceFile.created || '';
            this.modified = niceFile.modified || '';
            this.accessed = niceFile.accessed || '';
            this.authorID = niceFile.authorID || '';
            this.modifiedID = niceFile.modifiedID;
            this.size = niceFile.size;
            this.physicalBytes = niceFile.physicalBytes;
            this.numFiles = niceFile.numFiles;
            this.deleteTime = niceFile.deleteTime || '';
            this.purpose = niceFile.purpose || '';
            this.volumeID = niceFile.volumeID;
            this.physicalLocation = niceFile.physicalLocation || '';
            this.isDeleted = niceFile.isDeleted || false;
            this.volumeStatus = niceFile.volumeStatus || '';
            this.mailStatus = niceFile.mailStatus || '';
            this.childCount = niceFile.childCount;
            this.totalCount = niceFile.totalCount;
            this.totalPhysicalBytes = niceFile.totalPhysicalBytes;
            this.isAuthorized = niceFile.isAuthorized || false;
            this.cloudLocation = niceFile.cloudLocation || '';
            this.cloudEntryID = niceFile.cloudEntryID;
            this.needsProcessing = niceFile.needsProcessing || false;
            this.state = niceFile.state || '';
            this.purposeID = niceFile.purposeID;

            this.voiceId = niceFile.voiceId || '';
            this.translation = niceFile.translation || '';


            this.extension = this.fileName.substring(this.fileName.lastIndexOf('.') + 1, this.fileName.length);
            this.fileType = this.getFileTypeFromExt();
            if (this.isFolder) {
                this.location = this.fileNameWithPath;
            } else {
                this.location = this.fileNameWithPath.replace('/' + this.fileName, '');
                if (this.location.length === 0)
                {
                    this.location = '/';
                }
            }
            if (niceFile.aacFileInfo != null) {
                this.aacFileInfo = niceFile.aacFileInfo;
            } else {
                this.aacFileInfo = new AACFileInfo();
                this.aacFileInfo.fileTranscription = '';
                this.aacFileInfo.fileName = this.fileName;
                this.aacFileInfo.filePath = this.location;
            }
        } else {
            this.fileName = '';
            this.fileNameWithPath = '';
            this.isFolder = false;
        }
    }
    getWindowsFilePath(){
        return this.fileNameWithPath.replace(/\//g, '\\');
    }

    private getFileTypeFromExt(): string
    {
        if (this.isFolder)
        {
            return 'folder';
        }
        if (this.extension === 'csv' || this.extension === 'xls' || this.extension === 'xslx')
        {
            return 'spreadsheet';
        }
        if (this.extension === 'wav' || this.extension === 'wmv' || this.extension === 'mp4' || this.extension === 'mp3')
        {
            return 'audio';
        }
        return 'document';
    }
}

